import React from 'react';
import T from 'prop-types';
// components
import FormattedTemperature from 'components/FormattedTemperature';
// utils
import isNil from 'lodash.isnil';

// A day's low to high of one sensor, e.g. "66.9℉ – 82.9℉"
const FormattedTemperatureRange = ({ low, high, placeholder }) => (
  <>
    {isNil(low) ? placeholder : <FormattedTemperature value={low} />}
    {' – '}
    {isNil(high) ? placeholder : <FormattedTemperature value={high} />}
  </>
);

FormattedTemperatureRange.propTypes = {
  low: T.oneOfType([T.string, T.number]),
  high: T.oneOfType([T.string, T.number]),
  placeholder: T.node,
};

FormattedTemperatureRange.defaultProps = {
  placeholder: 'N/A',
};

export default FormattedTemperatureRange;
